export default {
  //Lets page view components set the appropriate class on the body.
  // The view must define the appropriate bodyClass in data()
  beforeMount() {
    window.document.body.className = this.bodyClass;
  },
};
